<div mat-dialog-content>
  <div class="mat-dialog-content">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="head-confirm-modal-list">
        <h2>Categorizações embutidas no protocolo {{this.healthGuideline.healthGuidelineName}}</h2>
      </div>

      <div class="body-confirm-modal-list">
        @for (item of listCategorization; track item) {
        <div class="row">
          <div class="categorization-description col-10">
            <h3 class="categorization-title">{{item.categorizationName}}</h3>
            <span>{{item.description}}</span>
          </div>
          <div class="col-2 radio-align">
            <input class="radio-sim" type="radio" [id]="'radio-' + item.idHealthGuidelineCategorization + '-sim'"
              [name]="isMultipleSelection ? 'checkbox-' + item.idHealthGuidelineCategorization : 'radio-sim'"
              [checked]="isSelected(item)" (click)="toggleCategorization(item)">
            <label class="label-radio-sim" [for]="'radio-' + item.idHealthGuidelineCategorization + '-sim'">
              <img src="assets/images/icone-radio-sim.svg" />
            </label>
          </div>
        </div>
        }

        @if (selectedCategorizations.length > 0) {
        <div>Data e hora de início do sintoma:</div>
        }

      </div>

      @if (selectedCategorizations.length > 0) {
      <div class="footer-confirm-modal-list">
        <div class="row">
          <div class="col-12 col-sm-8">
            <mat-form-field appearance="outline">
              <mat-label>Data</mat-label>
              <input matInput type="text" formControlName="symptomStartDate" [mask]="masks.date">
              @if (model.get('symptomStartDate')?.errors?.invalidDate) {
              <mat-error>{{model.get('symptomStartDate')?.errors?.invalidDate}}</mat-error>
              }
              @if (model.get('symptomStartDate').invalid && !model.get('symptomStartDate')?.errors?.invalidDate) {
              <mat-error>Informe
                a data de início do sintoma</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-6 col-sm-4">
            <mat-form-field appearance="outline">
              <mat-label>Hora</mat-label>
              <input matInput type="text" formControlName="symptomStartTime" [mask]="masks.timeUnit.mask"
                [pattern]="masks.timeUnit.pattern">
              @if (model.get('symptomStartTime').invalid) {
              <mat-error>Informe a hora de início do
                sintoma</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
      }

      <div class="col-12 button-container">
        <div class="col-5">
          <button mat-flat-button type="submit" color="primary" class="btn-block"
            [disabled]="selectedCategorizations.length === 0">
            <span>Continuar</span>
          </button>
        </div>
        <div class="col-5">
          <button mat-flat-button type="button" color="accent" class="btn-block" (click)="back()">
            <span>Voltar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>